export default __webpack_public_path__ + "static/media/same-mention-row.8ee3ae67.webm";